module.exports = __webpack_public_path__ + "media/audio3.5fc68f8c.wav";